import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './PageBanner.scss';

var settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
};

/* integrate react slick slider */
function PageBanner({ slides }) {
  const contents = slides.map(slide => {
    const { image: { src }, html } = slide;

    return (
      <div className="slide-wrapper">
        <div className="page-banner-slide" style={{ 'background-image': `url(${src})` }}>
          {html}
        </div>
      </div>
    );
  });

  return (
    <div className="page-banner">
      <Slider {...settings}>
        {contents}
      </Slider>
    </div>
  );
}

export default PageBanner;